import lazySizes from 'lazysizes'
import ee from '../ee'

function init() {
  lazySizes.init()
}

ee.addListener('initComponents', init)
